import {z} from '@hono/zod-openapi';

export const getHondaPartRequestSchema = z
  .object({
    partNumber: z.string().trim().min(1).max(50).openapi({example: 'AART1256J00'}),
  })
  .openapi('GetHondaPartRequest');

export type GetHondaPartRequest = z.infer<typeof getHondaPartRequestSchema>;
